import { render, staticRenderFns } from "./EditOrgDialog.vue?vue&type=template&id=7e79f5d8&scoped=true"
import script from "./EditOrgDialog.vue?vue&type=script&lang=js"
export * from "./EditOrgDialog.vue?vue&type=script&lang=js"
import style0 from "./EditOrgDialog.vue?vue&type=style&index=0&id=7e79f5d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e79f5d8",
  null
  
)

export default component.exports